<template>
	<button
		v-if="checklistVisible"
		type="button"
		class="tutorial-fab tutorial-fab--pill"
		@click="onClose"
	>
		<img
			src="@/assets/images/tutorial/fab-bg.png"
			alt=""
			class="tutorial-fab__bg"
		/>
		<img
			src="@/assets/images/tutorial/fab-check.svg"
			alt=""
			width="24"
			height="24"
			class="tutorial-fab__icon"
		/>
		<span class="tutorial-fab__label">Làm quen với Luca</span>
	</button>
	<button
		v-else-if="visible"
		type="button"
		class="tutorial-fab p-0 bg-transparent border-0 cursor-pointer"
		@click="onClick"
	>
		<img
			src="@/assets/images/icons/tutorial-shortcut.png"
			alt="Làm quen với Luca"
			class="h-12 w-12 block"
		/>
	</button>
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useTutorial } from '@/features/tutorial/useTutorial';

export default defineComponent({
	name: 'TutorialFab',
	emits: ['click', 'close'],
	setup(_, { emit }) {
		const { canAccessTutorial, isFabVisible, checklistExpanded, phase } =
			useTutorial();
		const visible = computed(() => isFabVisible.value);
		const checklistVisible = computed(
			() =>
				canAccessTutorial.value &&
				checklistExpanded.value &&
				(phase.value === 'tour' ||
					phase.value === 'step_success' ||
					phase.value === 'paused')
		);
		const onClick = () => emit('click');
		const onClose = () => emit('close');
		return { visible, checklistVisible, onClick, onClose };
	},
});
</script>

<style scoped>
.tutorial-fab {
	position: fixed;
	right: 24px;
	bottom: 24px;
	z-index: 40;
}
.tutorial-fab--pill {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 16px 12px 12px;
	border-radius: 100px;
	overflow: hidden;
	cursor: pointer;
}
.tutorial-fab--pill::after {
	content: '';
	position: absolute;
	inset: 0;
	border-radius: inherit;
	box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
	pointer-events: none;
}
.tutorial-fab__bg {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	max-width: none;
	object-fit: cover;
	pointer-events: none;
}
.tutorial-fab__icon,
.tutorial-fab__label {
	position: relative;
}
.tutorial-fab__label {
	font-size: 14px;
	line-height: 12px;
	font-weight: 600;
	letter-spacing: -0.28px;
	color: #fff;
	white-space: nowrap;
}
</style>
